<div class="billing-page">
    <sync-spinner *ngIf="isLoading"></sync-spinner>

    <ng-container *ngIf="!isLoading">
        <div class="plan-container">
            <div class="section-header">{{planName}}</div>
            <sync-alert *ngIf="cancelInFuture" [type]="'warning'" [showLeadIcon]="true" [leadIcon]="'warning'" [title]=""
            [description]="'This account is scheduled to be cancelled on ' + (planExpiry | date: 'mediumDate') + '.'" [showActions]="false" [showPrimaryAction]="false" 
            [showSecondaryAction]="false" [showCloseButton]="false"></sync-alert>

            <sync-alert *ngIf="planExpiryClose && !cancelInFuture && !user.is_on_trial" [type]="'warning'" [showLeadIcon]="true" [leadIcon]="'warning'" [title]=""
            [description]="'Your next renewal date is ' + (planExpiry | date: 'mediumDate') + '.'" [showActions]="false" [showPrimaryAction]="false" 
            [showSecondaryAction]="false" [showCloseButton]="false"></sync-alert>

            <sync-alert *ngIf="zbillingqueuepending.length > 0 && !user.is_on_trial"  [type]="'info'" [showLeadIcon]="true" [leadIcon]="'info'" [title]="'You have an upcoming plan change on ' + (zbillingqueuepending[0].contract_effective_date | date: 'longDate') + '.'"
            [description]="'If you wish to modify it please contact customer support at <a class=&quot;support-link&quot; href=&quot;https://www.sync.com/support/&quot; target=&quot;_blank&quot;>https://www.sync.com/support/</a>'" [showActions]="false" [showPrimaryAction]="false" 
            [showSecondaryAction]="false" [showCloseButton]="false"></sync-alert>

            <div class="plan-section">
                <div *ngIf="isPlanLoading" class="plan-spinner-wrapper">
                    <sync-spinner></sync-spinner>
                </div>
                <ng-container *ngIf="!isPlanLoading">
                    <div class="plan-flexbox">
                        <div class="doughnut-chart" *ngIf="!user.is_unlimited_plan">
                            <canvas baseChart [labels]="doughnutChartLabels" [datasets]="doughnutChartDatasets"
                                [options]="doughnutChartOptions" [legend]="false" type="doughnut">
                            </canvas>
                        </div>
                        <div class="doughnut-chart" *ngIf="user.is_unlimited_plan">
                            <img src="assets/icons/infinity.svg">
                        </div>
                        <div class="plan-details">
                            <div>
                                <div class="overline">STORAGE SPACE USED</div>
                                <div class="h4"><span [ngClass]="usageType">{{user.disk_usage_bytes |
                                        bytesToSize}}</span> / {{user.is_unlimited_plan ? 'Unlimited' : (user.disk_limit_bytes |
                                    bytesToSize)}}</div>
                            </div>
                            <div class="chart-legend">
                                <div class="chart-legend-sync">
                                    <div class="legend-color" [style.background]="chartColors[1]"></div>
                                    <div class="legend-text caption">Files</div>
                                    <div class="legend-size caption">{{du.syncbytes | bytesToSize}}</div>
                                </div>
                                <div class="chart-legend-vault">
                                    <div class="legend-color" [style.background]="chartColors[0]"></div>
                                    <div class="legend-text caption">Vault</div>
                                    <div class="legend-size caption">{{du.vaultbytes | bytesToSize}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="renewal-licenses-upgrade">
                        <div class="renewal-licenses">
                            <div class="renewal-details" *ngIf="renewalDate">
                                <div *ngIf="!user.is_on_trial">
                                    <div class="overline">RENEWAL DATE</div>
                                    <div class="h4">{{renewalDate}}</div>
                                </div>
                                <div *ngIf="user.is_on_trial">
                                    <div class="overline">TRIAL END DATE</div>
                                    <div class="h4">{{planExpiry | date: 'MMMM d, yyyy'}}</div>
                                </div>        
                            </div>
                            <div class="license-details" *ngIf="showPurchaseUsersOption && limit">
                                <div>
                                    <div class="overline">Users</div>
                                    <div class="h4">{{totalUsers}} / {{limit}}</div>
                                    <a *ngIf="canPurchaseUsers" class="body-2-link add-licences" (click)="clickPurchaseUsers()">Purchase more users</a>
                                </div>
                            </div>
                        </div>
                        <div class="upgrade" *ngIf="canManageBilling">
                            <sync-button *ngIf="canRenew()" type="outlined" [color]="buttonColor" label="Renew"  [size]="'medium'"
                            (click)="onRenewClick()"></sync-button>
                            <sync-button *ngIf="!(user.is_unlimited_plan && !user.is_on_trial)" type="filled" [color]="buttonColor" [label]="user.is_on_trial && zprofile ? 'Change plan' : 'Upgrade'"  [size]="'medium'"
                                (click)="onUpgradePlan()"></sync-button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="billing-section" *ngIf="userService.checkPermission(permissionActions.VIEW_BILLING)">
            <div class="section-header">Billing profile</div>
            <div [ngClass]="{'billing-auto-renew-container':(!zprofile.autoPay && !isBillingContextSet)}">
                <div class="billing-sync-alert">
                    <sync-alert type="promo" leadIcon="autorenew" [showLeadIcon]="true" title=""
                    [description]="autoRenewDescription" [showActions]="false" [showPrimaryAction]="false" [showSecondaryAction]="false"
                    [showCloseButton]="false" *ngIf="zprofile && !zprofile?.autoPay"></sync-alert>
                </div>
                <div class="billing-sync-list">
                    <sync-list [ListItems]="listItemsForBilling"></sync-list>
                </div>
            </div>
            <ng-container *ngIf="userService.checkPermission(permissionActions.MANAGE_BILLING) && !profileExists">
                <ng-container *ngIf="(!user.is_multi_new && !user.zuora_acct_key && user.plan_id === 1) || recordScrubbed">
                    <sync-alert type="warning" leadIcon="warning" [showLeadIcon]="true" title=""
                        [description]="user.is_on_trial 
                        ? 'Your account will be downgraded to the Free Starter account on your renewal date. Add a payment method and turn on auto-renew to keep your subscription.' 
                        : 'Your account will be on hold if not renewed after your renewal date. Add a payment method and turn on auto-renew to keep your subscription.'"
                        [showActions]="false"
                        [showPrimaryAction]="false"
                        [showSecondaryAction]="false"
                        [showCloseButton]="false"
                    ></sync-alert>
                    <div class="add-profile-wrapper">
                        <sync-list [ListItems]="addPaymentMethodList"></sync-list>
                    </div>
                </ng-container>
            </ng-container>
        </div>
        <div class="invoice-section"
            *ngIf="userService.checkPermission(permissionActions.VIEW_BILLING) && user.is_pro">
            <div class="section-header">Invoice history</div>
            <ng-container *ngIf="invoices.length > 0">
                <div class="caption invoice-count">{{invoices.length}} invoices available</div>
    
                <sync-list [ListItems]="invoiceListItems"></sync-list>
                <sync-pagination *ngIf="invoices.length > 10" alignment="right"
                    [length]="invoices.length" [pageSizeOptions]="pageObj.pageSizeOptions"
                    [onPageChange]="handlePageChange">
                </sync-pagination>
                <div class="dialogBody">
                    <sync-dialog [config]="{
                         title: 'Send invoice',
                         isClosable: true,
                         actionButton: 'Send',
                         cancelButton: 'Cancel',
                         onActionClick: sendEmail,
                         onCancelClick: onCancelClick,
                         isActionButtonDisabled: !(emails?.length) }" [open]="onSendInvoice" [onClose]="onCancelClick">
                        <div class="body send-invoive-block color-onsurface">
                            Send a copy of <span class="body-bold-1">{{selectedInvoice?.number}} ({{selectedInvoice?.date}})</span> to the
                            following emails:
                            <div class="email-container">
                                <sync-chip-email [disabled]="false" [label]="'Email address'" [readOnly]="false"
                                    [errorMessage]="'Enter a valid email address.'" [chipItems]="[]" [onError]=""
                                    [onChipValueChange]="onEmailChange"
                                    [chipLeadAdornment]="{
                                        enabled: true,
                                        type: 'avatar',
                                        size: 'large',
                                        avatarConfig: { type: 'avatar', size: 24, randomColor:true }
                                    }">
                                </sync-chip-email>
                            </div>
                        </div>
                    </sync-dialog>
                </div>
            </ng-container>
    
            <div *ngIf="!invoices || invoices.length <= 0 ">
                <p>No invoices available. Your invoices will appear here when they are ready.</p>
            </div>
        </div>
        <div class="body-1 billing-not-allowed" *ngIf="!userService.checkPermission(permissionActions.VIEW_BILLING) && user.is_pro">
            Please contact your administrator for billing inquiries.
        </div>
    </ng-container>
</div>

<div class="dialogBody">
    <sync-dialog [config]="{
      title: 'Edit auto renew settings',
      isClosable: false,
      actionButton: 'Save',
      cancelButton: 'Cancel',
      onActionClick: saveAutoRenew,
      onCancelClick: onCancelAutoRenewDialog,
      isButtonLoading: isAutoRenewLoading,
    }" [open]="isAutoRenewDialogOpen" [onClose]="onCancelAutoRenewDialog">

        <div class="body-2">
            Ensure you have continued access to your files by enabling automatic renewal of your Sync.com subscription.
        </div>
        <div class="auto-renew-container">

            <sync-switch size="large" label="Enable auto renew" labelPosition="before" [checked]="autoRenew"
                [onChange]="toggleRenewSwitch"></sync-switch>
        </div>
    </sync-dialog>
</div>